module.exports = __webpack_public_path__ + "img/5.94384a47.jpg";